import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Form, Field } from 'react-final-form'
import { TextField, RichText } from 'elentari'
import comentariosRepository from './ComentariosRepository'
import { Button } from '@material-ui/core'
import h2p from 'html2plaintext'
import toolbarConfig from './ToolbarConfig'

const ComentarioFormEmbarcador = ({
  onSubmit,
  handleReanalise,
  hasToken,
  ...props
}) => {
  const validate = data => {
    return {
      usuario: !hasToken
        ? undefined
        : data.usuario && data.usuario.trim() && !!h2p(data.usuario)
        ? undefined
        : 'Obrigatório',
      texto:
        data.texto && data.texto.trim() && !!h2p(data.texto)
          ? undefined
          : 'Obrigatório'
    }
  }

  const handleSubmit = async data => {
    const hasToken = !!props.match.params.token
    const tokenOrId = props.match.params.token || props.match.params.id

    const response = await (hasToken
      ? comentariosRepository.createByChatToken(tokenOrId, data)
      : comentariosRepository.createByJWT(tokenOrId, data))

    if (onSubmit) {
      onSubmit(response)
    }
  }

  return (
    <Form onSubmit={handleSubmit} validate={validate}>
      {({ handleSubmit, submitting, form }) => (
        <form
          onSubmit={event => {
            const promise = handleSubmit(event)
            promise &&
              promise.then(() => {
                form.resetFieldState('texto')
                hasToken && form.resetFieldState('usuario')
                form.reset()
              })
            return promise
          }}
        >
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12}>
              {hasToken && (
                <Field
                  fullWidth
                  name="usuario"
                  label="Nome"
                  component={TextField}
                />
              )}
            </Grid>
            <Grid item sm={12} xs={12}>
              <Field
                fullWidth
                name="texto"
                label="Comentário"
                component={RichText}
                toolbarConfig={toolbarConfig}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  style={{
                    width: 180
                  }}
                  type="submit"
                  disabled={submitting}
                  variant="contained"
                  color="primary"
                >
                  Comentar
                </Button>
                {hasToken && (
                  <Button
                    style={{
                      width: 200,
                      marginLeft: 16
                    }}
                    fullWidth
                    onClick={handleReanalise}
                    variant="contained"
                    color="secondary"
                  >
                    Solicitar Reanalise
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  )
}

export default ComentarioFormEmbarcador
